import api from './client';

// Streaks API - Streak tracking and milestones
export const streaksAPI = {
  // Get all available milestone definitions
  getMilestones: () =>
    api.get<{
      id: number;
      name: string;
      description: string;
      daysRequired: number;
      icon: string;
      color: string;
      pointsAwarded: number;
    }[]>('/streaks/milestones'),

  // Get current user's streak stats
  getMyStreakStats: (organizationId: number) =>
    api.get<{
      userStreak: {
        id: number;
        userId: number;
        organizationId: number;
        currentStreak: number;
        bestStreak: number;
        lastCompletionDate: string | null;
        totalTasksCompleted: number;
        totalRitualsCompleted: number;
        totalDaysActive: number;
        streakProtectionsAvailable: number;
        streakProtectionsUsed: number;
      };
      milestones: Array<{
        id: number;
        milestoneId: number;
        achievedAt: string;
        streakCount: number;
        milestone: {
          id: number;
          name: string;
          description: string;
          daysRequired: number;
          icon: string;
          color: string;
          pointsAwarded: number;
        };
      }>;
      nextMilestone: {
        id: number;
        name: string;
        description: string;
        daysRequired: number;
        icon: string;
        color: string;
        pointsAwarded: number;
      } | null;
      daysToNextMilestone: number;
      totalPoints: number;
    }>('/streaks/me', { params: { organizationId } }),

  // Get current user's achieved milestones
  getMyMilestones: (organizationId: number) =>
    api.get('/streaks/my-milestones', { params: { organizationId } }),

  // Get next milestone for a given streak
  getNextMilestone: (currentStreak: number) =>
    api.get('/streaks/next-milestone', { params: { currentStreak } }),

  // Use a streak protection
  useStreakProtection: (organizationId: number) =>
    api.post('/streaks/use-protection', { organizationId }),

  // Get streak leaderboard for organization
  getLeaderboard: (organizationId: number, limit?: number) =>
    api.get('/streaks/leaderboard', { params: { organizationId, limit } }),

  // Get milestone leaderboard for organization
  getMilestoneLeaderboard: (organizationId: number, limit?: number) =>
    api.get('/streaks/milestone-leaderboard', { params: { organizationId, limit } }),
};
